import { useTranslate } from '@tolgee/react';
import { GetServerSideProps } from 'next';
import { ReactElement } from 'react';

import SchoolAndFreePlanContent from '../../../components/_organisms/SchoolAndFreePlanContent';
import { NextPageWithLayout } from '../../../components/layouts';
import LandingPageLayout from '../../../components/layouts/LandingPageLayout';
import { getLocaleProps } from '../../../utils/localisationUtils';

interface LocalizedSchoolAndFreePlanProps {
  locale: string;
}

const LocalizedSchoolAndFreePlan: NextPageWithLayout<LocalizedSchoolAndFreePlanProps> = ({
  locale,
}) => {
  const { t } = useTranslate();
  const title = t('SchoolAndFreePlan.Meta.Title', 'Free vs School Plan — Curipod');
  const subTitle = t(
    'SchoolAndFreePlan.Meta.Description',
    'See what you get each week on the Curipod free plan, how School Plan Trials work, and how to bring Curipod to your whole school.',
  );

  return (
    <LandingPageLayout
      title={title}
      subTitle={subTitle}
      locale={locale}
      hideBlobs={true}
      disableHeadline={true}
    >
      <SchoolAndFreePlanContent />
    </LandingPageLayout>
  );
};

export const getServerSideProps: GetServerSideProps = async context => {
  return getLocaleProps(context);
};

LocalizedSchoolAndFreePlan.getLayout = function getLayout(page: ReactElement) {
  return <>{page}</>;
};

export default LocalizedSchoolAndFreePlan;
